export async function getUserDataFromLocalStorage() {
  try {
    const userDetails = await JSON.parse(localStorage.getItem("user"));
    return userDetails;
  } catch (error) {
    return null;
  }
}

export function setDataToLocalStorage(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {}
}

export async function getDataFromLocalStorage(key) {
  try {
    const data = await JSON.parse(localStorage.getItem(key));
    return data;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export function removeDataFromLocalStorage(key) {
  try {
    localStorage.removeItem(key);
  } catch (error) {}
}
